import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../../shared/shared.module';
import { HomeComponent } from './views/home/home.component';
import { FacturasComponent } from './views/facturas/facturas.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { SustentosRoutingModule } from './sustentos-routing.module';
import { ExportarComponent } from './views/exportar/exportar.component';
import { RetencionesComponent } from './views/retenciones/retenciones.component';

@NgModule({
    declarations: [
      HomeComponent,
      FacturasComponent,
      ExportarComponent,
      RetencionesComponent
    ],
    exports: [
      FacturasComponent,
      ExportarComponent,
      RetencionesComponent
    ],
    imports: [
      CommonModule,
      SustentosRoutingModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
      NgMultiSelectDropDownModule.forRoot()
    ]
  })
export class SustentosModule {}